import React from 'react';

import Layout from '../components/layout';
import { BannerAd } from '../components/ad';
import Grid from '../components/grid';
import Tile from '../components/tile';

export default ({ location: { pathname } }) => (
    <Layout pathname={pathname}>
        <Grid>
            <Tile href="/category/homes" title="Homes" image="home" />
            <Tile href="/category/cars" title="Cars" image="car" />
            <Tile href="/category/investments" title="Investments" image="investment" />
            <Tile href="/calculators" title="Calculators" image="calculator" />
            <Tile href="/articles" title="Articles" image="article" />
            <Tile href="/wyse-awards" title="Wyse Awards" image="awards" />
        </Grid>
    </Layout>
);
